import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { RouteConstant } from 'src/app/core/_constants/route.constant';
import { ApiServicesService } from 'src/app/services/apiServices/api-services.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-termofuse',
  templateUrl: './termofuse.component.html',
  styleUrls: ['./termofuse.component.scss']
})
export class TermofuseComponent implements OnInit {
  myProfile: any = true;
  isTermsOfUses: boolean = false;
  termsOfUseData: any = {};
  termsList: any[] = [];

  constructor(
    private commonService: CommonService,
    private service: ApiServicesService,
    private router: Router,
  ) { }
  ngOnInit(): void {
    window.scrollTo(0, 0);  
    this.TermsofUseAPIData()
  }

  goBack() {
    this.commonService.goBack();
  }

  TermsofUseAPIData() {
    const payload = {
      alias: 'terms-of-use',
    };
    this.service.post(payload, API_ROUTES.TermsofUseData.TermsofUseDataList, {})
      .subscribe((res) => {
        if (res.success) {
          console.log("res:",res)
          this.termsOfUseData = res.data;
          if(res.data.short_description){
            this.splitDescription(res.data.short_description);
          }else {
            this.termsList = [];
          }
        } else {
          console.error('Failed to fetch Terms of Use', res.message);
        }
      }
      );
  }
  splitDescription(description: string): void {
    this.termsList = description?.split('\n').map(point => point.trim()).filter(point => point.length > 0);
  }
  onToggleChange() {
    this.isTermsOfUses = !this.isTermsOfUses;
  }

  handleSaveChangesClick() {
    this.router.navigate([RouteConstant.mainhome])
  }
}
